import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_GET, llamadaAPI_GETBinario, llamadaAPI_POST, llamadaAPI_PUT } from '../../SQL';
import { TratamientoDeParametroParaURI } from '../../Varios';

export const function_INV_Remitos_Cabecera_Listar = async (FechaDesde, FechaHasta, IdTipoRemito) => {
    const NombreFuncion = "function_INV_Remitos_Cabecera_Listar"

    try {
        const resulData = await llamadaAPI_GET("INV_Remitos_Cabecera/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            IdTipoRemito);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};
export const function_INV_Remitos_Cabecera_ListarSoloClientesPropios = async (FechaDesde, FechaHasta, IdTipoRemito) => {
    const NombreFuncion = "function_INV_Remitos_Cabecera_ListarSoloClientesPropios"

    try {
        const resulData = await llamadaAPI_GET("INV_Remitos_Cabecera/ListarSoloClientesPropios/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            localStorage.getItem("IdPersona") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            IdTipoRemito);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_INV_Remitos_Cabecera_ListarArticulosRemitidos = async (FechaDesde, FechaHasta, IdTipoRemito) => {
    const NombreFuncion = "function_INV_Remitos_Cabecera_ListarArticulosRemitidos"

    try {
        const resulData = await llamadaAPI_GET("INV_Remitos_Cabecera/ListarArticulosRemitidos/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            IdTipoRemito);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_INV_Remitos_Cabecera_Leer = async (IdRemito) => {
    const NombreFuncion = "function_INV_Remitos_Cabecera_Leer"

    try {
        const resulData = await llamadaAPI_GET("INV_Remitos_Cabecera/Leer/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdRemito);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_INV_Remitos_Generar_JSON = async (IdRemito, IdTipoRemito, Fecha, IdCliente, NumeroFantasia,
    CodigoPuntoFiscal, Numero, CodigoMoneda, Cotizacion, ImporteBonificaciones, ImporteRecargos, 
    Concepto, Observaciones, 
    CodigoTransporte, IdTransportista, RemitoReverso, CodigoLocacion, EmpresaTransporte_CodigoEmpresaTransporte,
    EmpresaTransporte_CodigoLocacionEmpresaTransporte, EmpresaTransporte_Calle, EmpresaTransporte_Numero,
    EmpresaTransporte_Piso, EmpresaTransporte_Depto, EmpresaTransporte_CodigoPostal, EmpresaTransporte_IdCiudad,
    EmpresaTransporte_Email, EmpresaTransporte_Telefono, EmpresaTransporte_TelefonoFax,
    EmpresaTransporte_TelefonoCelular, EmpresaTransporte_HorarioAtencion, EmpresaTransporte_Responsable1,
    EmpresaTransporte_Responsable2, EmpresaTransporte_Responsable3, EmpresaTransporte_Observaciones,
    EmpresaTransporte_ABM_GEO_Ciudades_Descripcion, ColeccionDetalles, ColeccionImpuestos, ColeccionTransportes) => {
    const NombreFuncion = "function_INV_Remitos_Generar_JSON";

    try {
        const totalImporteNetoDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteNetoTotal, 0);
        const totalImporteBonificacionesDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteBonificacionesTotal, 0);
        const totalImporteRecargosDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteRecargosTotal, 0);
        const totalImporteSubTotalDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteSubTotalTotal, 0);
        const totalImporteIVADetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteIVATotal, 0);
        const totalImporteImpuestosInternosDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteImpuestosInternosTotal, 0);
        const totalImporteTotalDetalles = ColeccionDetalles.reduce((total, detalle) => total + detalle.ImporteTotalTotal, 0);
        const totalImporteTotalPostImpuestos = totalImporteTotalDetalles;

        let CotizacionMonedaReferente = 1;
        let ImporteTotalPostImpuestosMonedaReferente = totalImporteTotalPostImpuestos;

        if (!ImporteBonificaciones) {
            ImporteBonificaciones = 0
        }

        if (!ImporteRecargos) {
            ImporteRecargos = 0
        }

        const JSON = {
            IdRemito: IdRemito,
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            IdTipoRemito: IdTipoRemito,
            Fecha: Fecha,
            IdCliente: IdCliente,
            NumeroFantasia: NumeroFantasia,
            CodigoPuntoFiscal: CodigoPuntoFiscal,
            Numero: Numero,
            CodigoMoneda: CodigoMoneda,
            Cotizacion: Cotizacion,
            ImporteNeto: totalImporteNetoDetalles,
            ImporteBonificaciones: ImporteBonificaciones,
            ImporteRecargos: ImporteRecargos,
            ImporteBonificacionesItems: totalImporteBonificacionesDetalles,
            ImporteRecargosItems: totalImporteRecargosDetalles,
            ImporteTotal: totalImporteTotalDetalles,
            ImporteTotalPostImpuestos: totalImporteTotalPostImpuestos,
            ImporteRecibido: 0,
            Concepto: Concepto,
            Observaciones: Observaciones,
            IdEstado: 260,
            Terminal: localStorage.getItem("Terminal"), 
            CodigoTransporte: CodigoTransporte,
            IdTransportista: IdTransportista,
            RemitoReverso: RemitoReverso,
            CodigoLocacion: CodigoLocacion,
            EmpresaTransporte_CodigoEmpresaTransporte: EmpresaTransporte_CodigoEmpresaTransporte,
            EmpresaTransporte_CodigoLocacionEmpresaTransporte: EmpresaTransporte_CodigoLocacionEmpresaTransporte,
            EmpresaTransporte_Calle: EmpresaTransporte_Calle,
            EmpresaTransporte_Numero: EmpresaTransporte_Numero,
            EmpresaTransporte_Piso: EmpresaTransporte_Piso,
            EmpresaTransporte_Depto: EmpresaTransporte_Depto,
            EmpresaTransporte_CodigoPostal: EmpresaTransporte_CodigoPostal,
            EmpresaTransporte_IdCiudad: EmpresaTransporte_IdCiudad,
            EmpresaTransporte_Email: EmpresaTransporte_Email,
            EmpresaTransporte_Telefono: EmpresaTransporte_Telefono,
            EmpresaTransporte_TelefonoFax: EmpresaTransporte_TelefonoFax,
            EmpresaTransporte_TelefonoCelular: EmpresaTransporte_TelefonoCelular,
            EmpresaTransporte_HorarioAtencion: EmpresaTransporte_HorarioAtencion,
            EmpresaTransporte_Responsable1: EmpresaTransporte_Responsable1,
            EmpresaTransporte_Responsable2: EmpresaTransporte_Responsable2,
            EmpresaTransporte_Responsable3: EmpresaTransporte_Responsable3,
            EmpresaTransporte_Observaciones: EmpresaTransporte_Observaciones,
            EmpresaTransporte_ABM_GEO_Ciudades_Descripcion: EmpresaTransporte_ABM_GEO_Ciudades_Descripcion,
            Detalles: ColeccionDetalles.map(original => ({
                ...original,
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoPlanta: localStorage.getItem("CodigoPlanta")
              })),
            Impuestos: ColeccionImpuestos.map(original => ({
                ...original,
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoPlanta: localStorage.getItem("CodigoPlanta")
              })),
            Transportes: ColeccionTransportes
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_INV_Remitos_GenerarMedias_JSON = async (
    CodigoUbicacionOrigen, CodigoUbicacionDestino, CantidadMediasS, CantidadMediasM, CantidadMediasL) => {
    const NombreFuncion = "function_INV_Remitos_GenerarMedias_JSON";

    try {
        const JSONDetalles = [
            {
                "IdItem": 0,
                "IdRemito": 0,
                "CodigoCompania": localStorage.getItem("CodigoCompania"),
                "CodigoEmpresa": localStorage.getItem("CodigoEmpresa"),
                "CodigoPlanta": localStorage.getItem("CodigoPlanta"),
                "CodigoArticulo": "MS",
                "CodigoPresentacion": "DEF",
                "CodigoTamano": "DEF",
                "CodigoUnidadMedida": "UN",
                "Cantidad": CantidadMediasS,
                "CantidadFacturada": 0.0,
                "CantidadPedida": 0.0,
                "CantidadOT": 0.0,
                "ImporteNeto": 0,
                "ImporteIVA": 0,
                "ImporteNetoTotal": 0,
                "ImporteBonificacionesTotal": 0,
                "ImporteRecargosTotal": 0,
                "ImporteSubTotalTotal": 0,
                "ImporteIVATotal": 0,
                "ImporteImpuestosInternosTotal": 0,
                "ImporteTotalTotal": 0,
                "ImporteRecargos": 0.0,
                "ImporteDescuentos": 0.0,
                "ImporteTotal": 0,
                "PorcentajeIVA": 0,
                "Observaciones": "MEDIAS S",
                "CodigoUbicacionEgreso": CodigoUbicacionOrigen,
                "CodigoUbicacionIngreso": CodigoUbicacionDestino,
                "IdItemFactura": 0,
                "IdFactura": 0,
                "IdBulto": 0
            },
            {
                "IdItem": 0,
                "IdRemito": 0,
                "CodigoCompania": localStorage.getItem("CodigoCompania"),
                "CodigoEmpresa": localStorage.getItem("CodigoEmpresa"),
                "CodigoPlanta": localStorage.getItem("CodigoPlanta"),
                "CodigoArticulo": "MM",
                "CodigoPresentacion": "DEF",
                "CodigoTamano": "DEF",
                "CodigoUnidadMedida": "UN",
                "Cantidad": CantidadMediasM,
                "CantidadFacturada": 0.0,
                "CantidadPedida": 0.0,
                "CantidadOT": 0.0,
                "ImporteNeto": 0,
                "ImporteIVA": 0,
                "ImporteNetoTotal": 0,
                "ImporteBonificacionesTotal": 0,
                "ImporteRecargosTotal": 0,
                "ImporteSubTotalTotal": 0,
                "ImporteIVATotal": 0,
                "ImporteImpuestosInternosTotal": 0,
                "ImporteTotalTotal": 0,
                "ImporteRecargos": 0.0,
                "ImporteDescuentos": 0.0,
                "ImporteTotal": 0,
                "PorcentajeIVA": 0,
                "Observaciones": "MEDIAS M",
                "CodigoUbicacionEgreso": CodigoUbicacionOrigen,
                "CodigoUbicacionIngreso": CodigoUbicacionDestino,
                "IdItemFactura": 0,
                "IdFactura": 0,
                "IdBulto": 0
            },
            {
                "IdItem": 0,
                "IdRemito": 0,
                "CodigoCompania": localStorage.getItem("CodigoCompania"),
                "CodigoEmpresa": localStorage.getItem("CodigoEmpresa"),
                "CodigoPlanta": localStorage.getItem("CodigoPlanta"),
                "CodigoArticulo": "ML",
                "CodigoPresentacion": "DEF",
                "CodigoTamano": "DEF",
                "CodigoUnidadMedida": "UN",
                "Cantidad": CantidadMediasL,
                "CantidadFacturada": 0.0,
                "CantidadPedida": 0.0,
                "CantidadOT": 0.0,
                "ImporteNeto": 0,
                "ImporteIVA": 0,
                "ImporteNetoTotal": 0,
                "ImporteBonificacionesTotal": 0,
                "ImporteRecargosTotal": 0,
                "ImporteSubTotalTotal": 0,
                "ImporteIVATotal": 0,
                "ImporteImpuestosInternosTotal": 0,
                "ImporteTotalTotal": 0,
                "ImporteRecargos": 0.0,
                "ImporteDescuentos": 0.0,
                "ImporteTotal": 0,
                "PorcentajeIVA": 0,
                "Observaciones": "MEDIAS L",
                "CodigoUbicacionEgreso": CodigoUbicacionOrigen,
                "CodigoUbicacionIngreso": CodigoUbicacionDestino,
                "IdItemFactura": 0,
                "IdFactura": 0,
                "IdBulto": 0
            }
        ]

        const JSON = await function_INV_Remitos_Generar_JSON(0, 3, new Date(),
            null, null, null, null, "PA", 1, 0, 0, 0, "", "", null, null, false, null, null,
            null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,
            null, null, JSONDetalles, null, null)

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_INV_Remitos_Cabecera_Insertar = async (Remito) => {
    const NombreFuncion = "function_INV_Remitos_Cabecera_Insertar";

    try {
        const remitoResult = await llamadaAPI_POST("INV_Remitos_Cabecera/InsertarCompleto/",
            Remito);
        return remitoResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_INV_Remitos_Cabecera_Modificar = async (Cotizacion) => {
    const NombreFuncion = "function_INV_Remitos_Cabecera_Modificar";

    try {
        await llamadaAPI_PUT("INV_Remitos_Cabecera/ModificarCompleto", Cotizacion);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};
//HACER
export const function_INV_Remitos_Cabecera_LeerParaDocVenta = async (IdRemito) => {
    const NombreFuncion = "function_INV_Remitos_Cabecera_LeerParaDocVenta"

    try {
        const resulData = await llamadaAPI_GET("INV_Remitos_Cabecera/Leer/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdRemito);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_INV_Remitos_Cabecera_Eliminar = async (IdRemito) => {
    const NombreFuncion = "function_INV_Remitos_Cabecera_Eliminar"

    try {
        const resulData = await llamadaAPI_PUT("INV_Remitos_Cabecera/Eliminar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdRemito);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_INV_Remitos_Cabecera_ReporteRemito = async (IdRemito, formato) => {
    const NombreFuncion = "function_INV_Remitos_Cabecera_ReporteRemito";

    try {
        const resulData = await llamadaAPI_GETBinario("INV_Remitos_Cabecera/GenerarDocumento/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdRemito);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_INV_Remitos_Cabecera_ReporteRemito_EnvioMail = async (IdRemito, toEmail) => {
    const NombreFuncion = "function_INV_Remitos_Cabecera_ReporteRemito_EnvioMail";

    try {
        const resulData = await llamadaAPI_GET("INV_Remitos_Cabecera/EnvioMail/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdRemito + "/" +
            await TratamientoDeParametroParaURI(toEmail));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};